import $ from 'jquery';

window.$ = window.jQuery = $;
import 'jquery-datetimepicker';
import 'jquery-datetimepicker/jquery.datetimepicker.css';
import moment from "moment";

$(document).ready(function () {
    const busyByDay = window.busyDates ? window.busyDates : {};
    const agencyTime = window.working_hours ? window.working_hours : {}

    function getWorkingHours(day) {
        const weekDay = moment(day).format('dddd').toLowerCase();

        if ($.isEmptyObject(agencyTime)) {
            return null;
        }
        const exception = agencyTime.except[weekDay];

        if (exception) {
            if (exception === 'closed') {
                return null;
            }

            return {open: exception.open, close: exception.close}
        }

        return agencyTime.everyday;
    }

    function generateAllowedTimesForDay(day) {

        const busy = busyByDay[day] || [];
        const allowed = [];

        const workingHours = getWorkingHours(day);
        if (!workingHours) {
            // disable when the agency is closing
            return allowed;
        }

        const openTime = moment(`${day} ${workingHours.open}`, 'YYYY-MM-DD HH:mm');
        const closeTime = moment(`${day} ${workingHours.close}`, 'YYYY-MM-DD HH:mm');
        const minAllowedTime = moment().add(24, 'hours');

        for (let h = 0; h < 24; h++) {
            for (let m = 0; m < 60; m += 60) {
                const slotMoment = moment(`${day} ${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`, 'YYYY-MM-DD HH:mm');

                // Check if slot is before 24 hours from now
                if (slotMoment.isBefore(minAllowedTime)) {
                    continue;
                }

                if (slotMoment.isBefore(openTime) || !slotMoment.isBefore(closeTime)) {
                    continue;
                }

                const isBusy = busy.some(([start, end]) => {
                    const startMoment = moment(`${day} ${start}`, 'YYYY-MM-DD HH:mm');
                    const endMoment = moment(`${day} ${end}`, 'YYYY-MM-DD HH:mm');

                    return slotMoment.isSameOrAfter(startMoment) && slotMoment.isBefore(endMoment);
                });

                if (!isBusy) {
                    allowed.push(slotMoment.format('HH:mm'));
                }
            }
        }

        return allowed;
    }

    function setAllowedTimes(ct, pickerInstance) {
        if (!ct) return;
        const day = moment(ct).format('YYYY-MM-DD');
        const allowTimes = generateAllowedTimesForDay(day);

        pickerInstance.setOptions({allowTimes});
    }

    function disableDate(Instance) {
        setTimeout(() => {
            $('.xdsoft_date').each(function () {
                const year = $(this).data('year');
                const month = $(this).data('month') + 1; // zero-based months
                const date = $(this).data('date');
                const fullDateStr = `${year}-${month}-${date}`;
                const fullDate = moment(fullDateStr, 'YYYY-M-D').format('YYYY-MM-DD');

                const workingHours = getWorkingHours(fullDate);

                // Disable if closed
                if (!workingHours) {
                    $(this).addClass('xdsoft_disabled');
                    return;
                }

                // Disable if fully booked
                const allowedTimes = generateAllowedTimesForDay(fullDate);
                if (allowedTimes.length === 0) {
                    $(this).addClass('xdsoft_disabled');
                }
            });
        }, 10);
    }


    function findFirstAvailableDate() {
        for (let i = 0; i <= 30; i++) {
            const checkDate = moment().add(24, 'hours').add(i, 'days');
            const allowedTimes = generateAllowedTimesForDay(checkDate.format('YYYY-MM-DD'));
            if (allowedTimes.length > 0) {
                return checkDate.toDate();
            }
        }
        return moment().add(24, 'hours').toDate();
    }

    const picker = $('#datetimepicker').datetimepicker({
        format: 'Y-m-d H:i',
        step: 30,
        defaultDate: findFirstAvailableDate(),
        minDate: findFirstAvailableDate(),
        lang: 'nl',
        inline: true,
        onChangeDateTime: function (ct) {
            const day = moment(ct).format('YYYY-MM-DD');
            const allowTimes = generateAllowedTimesForDay(day);

            if (allowTimes.length === 0) {
                alert('Geen beschikbare tijden op deze datum. Kies een andere datum.');
                $('#datetimepicker').val('');
                return false;
            }

            setAllowedTimes(ct, this)
            disableDate(this)
        },
        onShow: function (ct) {
            setAllowedTimes(ct, this);
            disableDate(this)
        }
    });

    // Initialize after picker is created
    setTimeout(() => {
        const pickerInstance = picker.data('xdsoft_datetimepicker');
        if (pickerInstance) {
            const currentDate = findFirstAvailableDate();
            setAllowedTimes(currentDate, pickerInstance);
            disableDate(pickerInstance);
        }
    }, 100);
});
